module.exports = __webpack_public_path__ + "ssc_openBg.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lotteryRefactoring/lotteryImg/ssc_openBg.png
// module id = 806
// module chunks = 9